import React, { useEffect, useState, useRef } from "react";

import * as echarts from 'echarts';
import { formatNum } from "@/pages/intelligence/utils/commonUtils";
import ChartBubble from "@/pages/intelligence/components/ChartBubble";
import { useIntl } from 'umi';
export default function SingleLineChart(props: any) {
  const {
    data,
    color,
    name,
    chartStyle = {
      height: '230px',
      width: '100%',
    }
  } = props;
  // console.log("PIE", props)
  const { formatMessage } = useIntl();

  const ref = useRef<HTMLDivElement>(null);

  const getOptions = () => ({
    title: {
      show: false,
    },
    width: '100%',
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0)',
      padding: 0,
      borderWidth: 0,
      axisPointer: {
        type: 'line',
      },
      formatter(params: any[]) {
        return ChartBubble({
          data: params,
          secondTitleRight: formatMessage({id: 'dbi_revenue_$'}),
          // titleNow: 'Revenue($)',
          // titleNow: formatMessage({ id: 'dbi-sm-revenue' }) + '($)',
          chartType: 'line',
          ifNoBarImg: true,
        })
      },
    },
    legend: {
      icon: 'circle',
      itemWidth: 8,
      itemHeight: 8,
      bottom: 0,
      left: 'center',
      textStyle: {
        color: '#888888',
        fontSize: 12,
      },
      itemGap: 20,
      selectedMode: false
    },
    toolbox: {
      show: false,
    },
    grid: {
      top: '3%',
      right: '5%',
      width: '95%',
      bottom: 30,
      containLabel: true,
    },
    color,
    xAxis: [
      {
        type: 'category',
        // boundaryGap: ['0%','10%'],
        boundaryGap: false,
        data: data.xAxis,
      },
    ],
    yAxis: {
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed'
        }
      },
      axisLabel: {
        formatter(value) {
          return formatNum(value);
        },
      },
    },
    series: [
      {
        symbol: 'circle',
        symbolSize: 6,
        showSymbol: false,
        name,
        type: 'line',
        tooltip: {
          valueFormatter(value) {
            return formatNum(value);
          },
          backgroundColor: 'rgba(0,0,0,0)'
        },
        areaStyle: {
          opacity: 0.4,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#F2F3F5' },
            { offset: 0, color }
          ])
        },
        data: data.yAxis,
      },
    ],
  })

  const handleResize = (chart) => {
    if (ref?.current) {
      chart.resize();
    }
  };

  useEffect(() => {
    let myChart;
    let listener: null | (() => void) = null;

    if (ref.current) {
      const options = getOptions();
      // canvas
      myChart = echarts.init(ref.current, undefined, { renderer: 'canvas' });
      myChart.setOption(options, { notMerge: true });
      listener = () => {
        handleResize(myChart);
      };

      window.addEventListener('resize', listener);
    }

    return () => {
      if (myChart && listener !== null) {
        window.removeEventListener('resize', listener);
        myChart.off();
      }
    };
  }, [props]);

  return (
    <div style={{ ...chartStyle }}>
      <div ref={ref} style={chartStyle}></div>
    </div>
  );
}